import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full h-full justify-start items-start bg-white overflow-y-auto" }
const _hoisted_2 = { class: "flex flex-col px-4 gap-4 mt-4 w-full items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_location = _resolveComponent("location")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu_item_group = _resolveComponent("el-menu-item-group")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_icon_menu = _resolveComponent("icon-menu")!
  const _component_document = _resolveComponent("document")!
  const _component_setting = _resolveComponent("setting")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "w-full h-12 p-4 shadow-md" }, [
      _createElementVNode("span", { class: "text-large text-black text-bold font-600 mr-3" }, "Layout1")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_radio_group, {
        modelValue: _ctx.isCollapse,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isCollapse) = $event)),
        style: {"margin-bottom":"20px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_radio_button, { value: false }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("expand")
            ])),
            _: 1
          }),
          _createVNode(_component_el_radio_button, { value: true }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode("collapse")
            ])),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_menu, {
        "default-active": "2",
        class: "el-menu-vertical-demo",
        collapse: _ctx.isCollapse,
        onOpen: _ctx.handleOpen,
        onClose: _ctx.handleClose
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_sub_menu, { index: "1" }, {
            title: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_location)
                ]),
                _: 1
              }),
              _cache[3] || (_cache[3] = _createElementVNode("span", null, "Navigator One", -1))
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item_group, null, {
                title: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createElementVNode("span", null, "Group One", -1)
                ])),
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, { index: "1-1" }, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createTextVNode("item one")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, { index: "1-2" }, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createTextVNode("item two")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item_group, { title: "Group Two" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, { index: "1-3" }, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode("item three")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_sub_menu, { index: "1-4" }, {
                title: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createElementVNode("span", null, "item four", -1)
                ])),
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, { index: "1-4-1" }, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createTextVNode("item one")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "2" }, {
            title: _withCtx(() => _cache[10] || (_cache[10] = [
              _createTextVNode("Navigator Two")
            ])),
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_icon_menu)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, {
            index: "3",
            disabled: ""
          }, {
            title: _withCtx(() => _cache[11] || (_cache[11] = [
              _createTextVNode("Navigator Three")
            ])),
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_document)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "4" }, {
            title: _withCtx(() => _cache[12] || (_cache[12] = [
              _createTextVNode("Navigator Four")
            ])),
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_setting)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["collapse", "onOpen", "onClose"])
    ])
  ]))
}